module.exports = __webpack_public_path__ + "img/DSCN2053.396da84c.jpg";